import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const [isAuth, setIsAuth] = useState(null); // null means "checking..."

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsAuth(!!token); 
  }, []);

  if (isAuth === null) {
    return <div></div>; 
  }

  return isAuth ? children : <Navigate to="/" />;
};

export default PrivateRoute;
